import { useQuery } from '@tanstack/react-query';
import { getTags } from '../actions/tags';

export const TAGS_QUERY_KEY = 'tags';

export const useTagsQuery = () => {
  return useQuery({
    queryKey: [TAGS_QUERY_KEY],
    queryFn: async () => {
      return await getTags();
    },
    throwOnError: false,
  });
};
